import SearchMessages from "./SearchMessages";

export default SearchMessages;
